import React from "react";

// A vertical 1080x1920 Story-friendly layout of the memorial.
// Rendered off-screen and snapped to PNG via html2canvas.
// Designed to look beautiful when posted to Instagram / TikTok Stories.
export default function MemorialStoryCard({ memorial }) {
  if (!memorial) return null;
  const bg = memorial.scenery_image_base64
    ? `data:${memorial.scenery_mime_type || "image/jpeg"};base64,${memorial.scenery_image_base64}`
    : null;
  const portrait = memorial.pet_photo_base64
    ? `data:${memorial.pet_photo_mime_type || "image/jpeg"};base64,${memorial.pet_photo_base64}`
    : null;

  // First 4 lines of poem (Stories are vertical; keep concise)
  const poemSnippet = (memorial.poem || "")
    .split("\n")
    .filter((l) => l.trim())
    .slice(0, 4)
    .join("\n");

  return (
    <div
      style={{
        width: 1080,
        height: 1920,
        position: "relative",
        fontFamily: "'Cormorant Garamond', Georgia, serif",
        background: "#FDFBF7",
        overflow: "hidden",
      }}
    >
      {/* Background image */}
      {bg ? (
        <img src={bg} alt="" style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg,#F2E3C6,#FDFBF7)" }} />
      )}
      {/* Soft white scrim for legibility */}
      <div style={{ position: "absolute", inset: 0, background: "linear-gradient(180deg, rgba(253,251,247,0.05) 0%, rgba(253,251,247,0.55) 50%, rgba(253,251,247,0.95) 100%)" }} />

      {/* Top brand */}
      <div style={{ position: "absolute", top: 80, left: 0, right: 0, textAlign: "center" }}>
        <div style={{ color: "#D4AF37", letterSpacing: "0.32em", fontSize: 22, fontFamily: "Arial, sans-serif", textTransform: "uppercase", fontWeight: 500 }}>
          The Heirloom Pet
        </div>
        <div style={{ height: 1, width: 220, background: "#D4AF37", opacity: 0.5, margin: "20px auto 0" }} />
      </div>

      {/* Center memorial card */}
      <div style={{
        position: "absolute", left: 80, right: 80, top: 880, bottom: 220,
        background: "rgba(253,251,247,0.94)",
        border: "1px solid rgba(212,175,55,0.45)",
        boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.9), 0 30px 80px -20px rgba(212,175,55,0.4)",
        padding: 64,
        textAlign: "center",
      }}>
        <div style={{ color: "#D4AF37", letterSpacing: "0.32em", fontSize: 20, fontFamily: "Arial, sans-serif", textTransform: "uppercase", fontWeight: 500 }}>
          In Loving Memory
        </div>
        <div style={{ fontSize: 96, fontStyle: "italic", color: "#2C2825", marginTop: 32, lineHeight: 1.0 }}>
          {memorial.pet_name}
        </div>
        {memorial.dates && (
          <div style={{ color: "#7A736E", fontStyle: "italic", fontSize: 30, marginTop: 18 }}>
            {memorial.dates}
          </div>
        )}
        <div style={{ color: "#D4AF37", fontSize: 28, margin: "32px 0" }}>✦</div>
        {poemSnippet && (
          <div style={{ fontSize: 34, fontStyle: "italic", color: "#2C2825", lineHeight: 1.55, whiteSpace: "pre-line" }}>
            {poemSnippet}
          </div>
        )}
      </div>

      {/* Pet portrait — circular, sitting over the card edge */}
      {portrait && (
        <div style={{
          position: "absolute", left: "50%", top: 760, transform: "translateX(-50%)",
          width: 260, height: 260, borderRadius: "50%", overflow: "hidden",
          border: "8px solid #FDFBF7",
          boxShadow: "0 0 0 3px #D4AF37, 0 30px 60px -15px rgba(212,175,55,0.5)",
        }}>
          <img src={portrait} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        </div>
      )}

      {/* Footer */}
      <div style={{ position: "absolute", left: 0, right: 0, bottom: 110, textAlign: "center" }}>
        <div style={{ color: "#7A736E", fontSize: 24, fontStyle: "italic" }}>
          {memorial.owner_display_name || "Their forever family"}
        </div>
        <div style={{ height: 1, width: 180, background: "#D4AF37", opacity: 0.5, margin: "28px auto" }} />
        <div style={{ color: "#D4AF37", letterSpacing: "0.28em", fontSize: 16, fontFamily: "Arial, sans-serif", textTransform: "uppercase" }}>
          theheirloompet.com
        </div>
      </div>
    </div>
  );
}
